import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_AWARD_TYPES,
    fetchAwardTypesSuccessful
} from '../actions'



function * fetchAwardTypes (paylaod){
    try{
       const response=  yield call(DCore.get, '/awards/types')
        yield put (fetchAwardTypesSuccessful(response.data))

    }catch(e){
        console.log("some thing went wrong", e)
    }
}



export function * AwardTypesSaga(){
    yield takeLatest(FETCH_AWARD_TYPES,fetchAwardTypes)
}